var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStocksList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 24H7C4.243 24 2 21.757 2 19V5C2 2.243 4.243 0 7 0H17C19.757 0 22 2.243 22 5V19C22 21.757 19.757 24 17 24ZM7 2C5.346 2 4 3.346 4 5V19C4 20.654 5.346 22 7 22H17C18.654 22 20 20.654 20 19V5C20 3.346 18.654 2 17 2H7ZM18 6C18 5.448 17.552 5 17 5H13C12.448 5 12 5.448 12 6C12 6.552 12.448 7 13 7H17C17.552 7 18 6.552 18 6ZM18 12C18 11.448 17.552 11 17 11H13C12.448 11 12 11.448 12 12C12 12.552 12.448 13 13 13H17C17.552 13 18 12.552 18 12ZM18 18C18 17.448 17.552 17 17 17H13C12.448 17 12 17.448 12 18C12 18.552 12.448 19 13 19H17C17.552 19 18 18.552 18 18ZM10 7V5C10 4.448 9.552 4 9 4H7C6.448 4 6 4.448 6 5V7C6 7.552 6.448 8 7 8H9C9.552 8 10 7.552 10 7ZM10 13V11C10 10.448 9.552 10 9 10H7C6.448 10 6 10.448 6 11V13C6 13.552 6.448 14 7 14H9C9.552 14 10 13.552 10 13ZM10 19V17C10 16.448 9.552 16 9 16H7C6.448 16 6 16.448 6 17V19C6 19.552 6.448 20 7 20H9C9.552 20 10 19.552 10 19Z",
    fill: "#0084D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocksList);
export default __webpack_public_path__ + "static/media/stocks-list.b5faa0ec0302ec514ae7d4df5ac63cf4.svg";
export { ForwardRef as ReactComponent };